import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { hideSpinner, showSpinner, getErrorMessage, ignoreSpecialCharacters, getCurrentUser } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { LogisticaService } from '../services/logistica.service';
import { CrearPoligonoComponent } from '../crear-poligono/crear-poligono.component';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service'
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {ModalAlertasComponent} from '../modal-alertas/modal-alertas.component';

@Component({
  selector: 'app-dialog-combo-creation',
  templateUrl: './dialog-combo-creation.component.html',
  styleUrls: ['./dialog-combo-creation.component.scss']
})
export class DialogComboCreationComponent implements OnInit {

  actions = {
    new: 'Guardar',
    edit: 'Actualizar',
    delete: 'Eliminar',
    departamento: 'Guardar',
    municipio: 'Guardar',
    zona: 'Guardar',
    new_capa: 'Guardar',
    new_alert: 'Guardar',
    edit_alert: 'Actualizar',
    estado_alert:'estado_alert'
  };
  action: any = null;
  title: any = null;
  form: FormGroup
  departamentos: Observable<any[]> = of([]);
  municipios: Observable<any[]> = of([]);
  zonas: Observable<any[]> = of([]);
  departamentosOriginal: any[] = [];
  municipiosOriginal: any[] = [];
  zonasOriginal: any[] = [];

  departamentosSeleccionados: any[] = [];
  municipiosSeleccionados: any[] = [];
  zonasSeleccionados: any[] = [];

  filtroDepartamento: string = '';
  filtroMunicipio: string = '';
  filtroZona: string = '';
  departamentoControl = new FormControl();
  municipioControl = new FormControl();
  zonaControl = new FormControl();
  filtroBodega: FormControl = new FormControl();
  storeBodegas: Item[] = [];
  bodegasFiltradas: Observable<Item[]>;
  cierre_automatico: any = 'N';
  cubicaje: any;
  cantidad_ops: any;
  cod_bodega: any;
  capacidadPorDia: boolean = false;
  fechasSeleccionadas: Date[] = [];
  calendarioAbierto: boolean = false;
  
  @ViewChild('picker') datePicker!: MatDatepicker<Date>;

  constructor(
    public dialogRef: MatDialogRef<DialogComboCreationComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private helpers: HelpersService,
    private logisticaService: LogisticaService,
    private commonService: CommonService,
    private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      cod_poligono: ["", [Validators.required]],
      nom_poligono: ["", [Validators.required]],
      estado_legible: ["A"],
      departamentos: [""],
      municipios: [""],
      zonas: [""],
      cierre_automatico: ["N"],
      cubicaje: [""],
      cantidad_ops: [""],
      porcentaje_cierre: [""],
      cod_bodega: [""],
      PORC_AVANCE: [""],
      ASUNTO: [""],
      DESTINATARIOS: [""]
    })


  }

  async ngOnInit(): Promise<void> {
    this.action = this.data.action;
    switch (this.action) {
      case 'new':
        this.title = 'Nuevo poligono';
        break;
      case 'edit':
        this.title = 'Editar poligono';
        // this.form.controls['type'].disable(); //setValue
        this.form.patchValue({
          cod_poligono: this.data.COD_POLIGONO,
          nom_poligono: this.data.NOMBRE_POLIGONO,
          estado_legible: this.data.ESTADO_LEGIBLE == 'Activo' ? 'A' : 'I'
        });

        break;
      case 'delete':
        this.actions.delete = `${this.data?.ESTADO_LEGIBLE == 'Activo' ? 'Inactivar' : 'Activar'}`
        this.title = `${this.data?.ESTADO_LEGIBLE == 'Activo' ? 'Inactivar' : 'Activar'} poligono`
        break;
      case 'departamento':
        this.title = 'Agregar Departamentos';
        this.cargarDepartamentos();
        break;
      case 'municipio':
        this.title = 'Agregar Municipios';
        this.cargarMunicipios();
        break;
      case 'zona':
        this.title = 'Agregar Zonas';
        this.cargarZonas();
        break;
      case 'new_alert':
        this.title = 'Nueva Alerta';
        break;
      case 'edit_alert':
        this.title = 'Editar Alerta';
        this.form.patchValue({
          PORC_AVANCE: this.data.PORC_AVANCE,
          ASUNTO: this.data.ASUNTO,
          DESTINATARIOS: this.data.DESTINATARIOS
        });
        break;
      case 'estado_alert':
        this.actions.estado_alert = `${this.data?.ESTADO == 'A' ? 'Inactivar' : 'Activar'}`
        this.title = `${this.data?.ESTADO == 'A' ? 'Inactivar' : 'Activar'} alerta`
        break;

    }

    //Cargar Zonas
    const bodegas = await this.commonService.findAllBodegas()
    this.storeBodegas = bodegas.data.map((d) => {
      return {
        cod: d.c_bod,
        nombre: d.nom
      }
    })

    // Configurar el filtro de bodegas
    this.bodegasFiltradas = this.filtroBodega.valueChanges.pipe(
      startWith(''),
      map(value => this._filtrarBodegas(value || ''))
    );

    console.log('bodegas cargadas:', this.storeBodegas);

    // Si estamos en modo new_capa, verificamos si hay una bodega preseleccionada
    if (this.action === 'new_capa' && this.data.cod_bodega) {
      const bodegaPreseleccionada = this.storeBodegas.find(b => b.cod === this.data.cod_bodega);
      if (bodegaPreseleccionada) {
        this.filtroBodega.setValue(bodegaPreseleccionada);
        this.form.patchValue({
          cod_bodega: bodegaPreseleccionada.cod
        });
      }
    }
  }
  async create() {

    showSpinner()
    if (this.action == 'new' || this.action == 'edit') {
      if (this.form.valid) {
        if (this.action == 'new') {

          try {
            const usuario = getCurrentUser().usuario_aplicativo || '';

            const resultado = await this.logisticaService.crear_poligono(
              this.form.value.cod_poligono,
              this.form.value.nom_poligono,
              usuario
            );
            if (resultado.success) {
              this.helpers.notifications.successMessage("Polígono creado exitosamente");
              await CrearPoligonoComponent.changeValueDialog(1);
              this.dialogClose();
              /* this.dialogRef.close({ success: true, refresh: true, tipo:'new'}); */
            } else {
              this.helpers.notifications.errorMessage(resultado.message)
            }
            hideSpinner()
          } catch (error) {
            hideSpinner()
            const message = getErrorMessage(error)
            this.helpers.notifications.errorMessage(message)
          }
        } else {
          try {
            const usuario = getCurrentUser().usuario_aplicativo || '';
            this.form.value.id_poli = this.data.ID_POLI
            const result = await this.logisticaService.update_poligono(
              this.form.value.id_poli,
              this.form.value.nom_poligono,
              this.form.value.estado_legible,
              usuario
            )
            if (result.success) {
              this.helpers.notifications.successMessage(result.message);
              await CrearPoligonoComponent.changeValueDialog(1);
              this.dialogClose();
              /*  this.dialogRef.close({ success: true, refresh: true, tipo:'edit', id_poli:this.form.value.id_poli }); */
            } else {
              this.helpers.notifications.errorMessage(result.message)
            }
            hideSpinner()
          } catch (error) {
            hideSpinner()
            const message = getErrorMessage(error)
            this.helpers.notifications.errorMessage(message)
          }
        }
      } else {

        hideSpinner()
        this.helpers.notifications.errorMessage("Todos los campos son obligatorios")
      }
    } else if (this.action == 'delete') {
      try {
        const id_poli = this.data.ID_POLI
        const nombre_poligono = this.data.NOMBRE_POLIGONO
        // Invertir el estado actual del polígono
        const estado_legible = this.data.ESTADO_LEGIBLE === 'Activo' ? 'I' : 'A'
        const usuario = getCurrentUser().usuario_aplicativo || '';
        const result = await this.logisticaService.update_poligono(
          id_poli,
          nombre_poligono,
          estado_legible,
          usuario
        )
        if (result.success) {
          this.helpers.notifications.successMessage(result.message);
          await CrearPoligonoComponent.changeValueDialog(1);
          this.dialogClose();
          /* this.dialogRef.close({ success: true, refresh: true, tipo:'delete', id_poli:id_poli }); */
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else if (this.action == 'departamento') {
      if (this.departamentosSeleccionados.length > 0) {
        const dataToSend: any[] = [];
        for (const depto of this.departamentosSeleccionados) {
          const cod_dpto = depto?.CODIGO_DEPARTAMENTO || '';
          console.log(this.data.ID_POLI)
          dataToSend.push({
            id_poli: this.data.ID_POLI,
            cod_dpto: cod_dpto,
            cod_mnpo: '',
            cod_zona_log: '',
            usuario_creacion: getCurrentUser().usuario_aplicativo || ''
          });
        }
        try {
          const resultado = await this.logisticaService.crear_geografia({ geografias: dataToSend });
          if (resultado.success) {
            this.helpers.notifications.successMessage("Registros creados exitosamente");
            await CrearPoligonoComponent.changeValueDialog(1);
            this.dialogClose(); // Cerrar el diálogo para volver a la selección del polígono
            /*  this.dialogRef.close({ success: true, refresh: true, tipo:'departamento', id_poli:this.data.ID_POLI}); */
          } else {
            this.helpers.notifications.errorMessage(resultado.message);
          }
          hideSpinner(); // Ocultar el spinner después de completar la operación
        } catch (error) {
          hideSpinner(); // Ocultar el spinner en caso de error
          const message = getErrorMessage(error);
          this.helpers.notifications.errorMessage(message);
        }
      } else {
        hideSpinner(); // Ocultar el spinner si no hay departamentos seleccionados
        this.helpers.notifications.errorMessage("Debe seleccionar al menos un departamento");
      }
    } else if (this.action == 'municipio') {
      if (this.municipiosSeleccionados.length > 0) {
        const dataToSend: any[] = [];
        for (const municipio of this.municipiosSeleccionados) {
          const cod_dpto = municipio?.CODIGO_DEPARTAMENTO || '';
          const cod_munici = municipio?.CODIGO_MUNICIPIO || '';
          console.log(this.data.ID_POLI)
          dataToSend.push({
            id_poli: this.data.ID_POLI,
            cod_dpto: cod_dpto,
            cod_mnpo: cod_munici,
            cod_zona_log: '',
            usuario_creacion: getCurrentUser().usuario_aplicativo || ''
          });
        }
        try {
          const resultado = await this.logisticaService.crear_geografia({ geografias: dataToSend });
          if (resultado.success) {
            this.helpers.notifications.successMessage("Registros creados exitosamente");
            await CrearPoligonoComponent.changeValueDialog(1);
            this.dialogClose();
            /*  this.dialogRef.close({ success: true, refresh: true, tipo:'municipio', id_poli:this.data.ID_POLI }); */
          } else {
            this.helpers.notifications.errorMessage(resultado.message);
          }
          hideSpinner();
        } catch (error) {
          hideSpinner();
          const message = getErrorMessage(error);
          this.helpers.notifications.errorMessage(message);
        }
      } else {
        hideSpinner();
        this.helpers.notifications.errorMessage("Debe seleccionar al menos un municipio");
      }
    } else if (this.action == 'zona') {
      if (this.zonasSeleccionados.length > 0) {
        const dataToSend: any[] = [];
        for (const zona of this.zonasSeleccionados) {
          const cod_dpto = zona?.CODIGO_DEPARTAMENTO || '';
          const cod_munici = zona?.CODIGO_MUNICIPIO || '';
          const cod_zona = zona?.CODIGO_ZONA || '';
          console.log(this.data.ID_POLI)
          dataToSend.push({
            id_poli: this.data.ID_POLI,
            cod_dpto: cod_dpto,
            cod_mnpo: cod_munici,
            cod_zona_log: cod_zona,
            usuario_creacion: getCurrentUser().usuario_aplicativo || ''
          });
        }
        try {
          const resultado = await this.logisticaService.crear_geografia({ geografias: dataToSend });
          if (resultado.success) {
            this.helpers.notifications.successMessage("Registros creados exitosamente");
            await CrearPoligonoComponent.changeValueDialog(1);
            this.dialogClose();
            /*  this.dialogRef.close({ success: true, refresh: true, tipo:'zona', id_poli:this.data.ID_POLI }); */
          } else {
            this.helpers.notifications.errorMessage(resultado.message);
          }
          hideSpinner();
        } catch (error) {
          hideSpinner();
          const message = getErrorMessage(error);
          this.helpers.notifications.errorMessage(message);
        }
      } else {
        hideSpinner();
        this.helpers.notifications.errorMessage("Debe seleccionar al menos un municipio");
      }
    } else if (this.action == 'new_capa') {
      try {
        showSpinner();
        const usuario = getCurrentUser().usuario_aplicativo || '';
        const id_poli = this.data.ID_POLI;
        
        console.log('Datos recibidos en el modal:', this.data);
        console.log('ID_POLI extraído:', id_poli);
        
        if (!id_poli) {
          this.helpers.notifications.errorMessage("No se encontró el ID del polígono");
          hideSpinner();
          return;
        }

        // Obtener los valores actualizados del formulario
        const formValues = this.form.getRawValue();

        // Verificar si cod_bodega está vacío y usar la propiedad del componente si es necesario
        const cod_bodega = formValues.cod_bodega || this.cod_bodega;

        // Validar campos requeridos
        if (!cod_bodega) {
          this.helpers.notifications.errorMessage("Debe seleccionar una bodega");
          hideSpinner();
          return;
        }

        if (this.capacidadPorDia && this.fechasSeleccionadas.length === 0) {
          this.helpers.notifications.errorMessage("Debe seleccionar al menos una fecha para capacidad por día");
          hideSpinner();
          return;
        }

        console.log('Valores del formulario antes de enviar:', {
          id_poli,
          cod_bodega,
          cierre_automatico: formValues.cierre_automatico || this.cierre_automatico,
          porcentaje_cierre: formValues.porcentaje_cierre,
          cubicaje: formValues.cubicaje,
          cantidad_ops: formValues.cantidad_ops,
          capacidadPorDia: this.capacidadPorDia,
          fechasSeleccionadas: this.fechasSeleccionadas
        });

        let resultado;
        
        if (this.capacidadPorDia) {
          // Validar que ninguna de las fechas seleccionadas ya tenga una capacidad por día creada
          const existentesResp = await this.logisticaService.obtener_capacidades_dias(id_poli);
          const capacidadesDiaExistentes: any[] = existentesResp?.success ? (existentesResp.data || []) : [];

          const formatearFecha = (fecha: Date): string => {
            const year = fecha.getFullYear();
            const month = String(fecha.getMonth() + 1).padStart(2, '0');
            const day = String(fecha.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
          };

          const fechasDuplicadas = this.fechasSeleccionadas
            .map(f => formatearFecha(f))
            .filter(fechaStr => capacidadesDiaExistentes.some(c =>
              c.COD_BODEGA === cod_bodega && String(c.FECHA_DIA).substring(0, 10) === fechaStr
            ));

          if (fechasDuplicadas.length > 0) {
            this.helpers.notifications.errorMessage(
              `Ya existe una capacidad para la bodega ${cod_bodega} en la(s) fecha(s) ${fechasDuplicadas.join(', ')}. Edite la capacidad existente en lugar de crear una nueva.`
            );
            hideSpinner();
            return;
          }

          // Crear capacidades por día - llamar al nuevo servicio
          resultado = await this.logisticaService.crear_capacidades_por_dia(
            id_poli,
            cod_bodega,
            formValues.cierre_automatico || this.cierre_automatico,
            formValues.porcentaje_cierre,
            formValues.cubicaje,
            formValues.cantidad_ops,
            this.fechasSeleccionadas,
            usuario
          );
          
          if (resultado.success) {
              const mensaje = this.capacidadPorDia ? "Capacidades por día creadas exitosamente" : "Capacidades creadas exitosamente";
          
              const ids: number[] = resultado.id_reg_cal ?? [];

              await Promise.all(
                ids.map((id: number) =>
                  this.logisticaService.crearAlertasAutomaticas(String(id), usuario)
                )
              );
              
              this.helpers.notifications.successMessage(mensaje);
              await CrearPoligonoComponent.changeValueDialog(1);
              this.dialogClose();
        } else {
          this.helpers.notifications.errorMessage(resultado.message || 'No se pudieron crear las capacidades.');
        }
        } else {
          // Crear capacidad general - validar que no exista ya una capacidad general para esta bodega
          const capacidadesExistentes: any[] = this.data.capacidadesExistentes || [];
          const yaExiste = capacidadesExistentes.some(c =>
            c.COD_BODEGA === cod_bodega && (c.TIPO_CAPACIDAD ? c.TIPO_CAPACIDAD === 'GENERAL' : !!c.ID_REG)
          );

          if (yaExiste) {
            this.helpers.notifications.errorMessage(
              `Ya existe una capacidad general para la bodega ${cod_bodega} en este polígono. Edite la capacidad existente en lugar de crear una nueva.`
            );
            hideSpinner();
            return;
          }

          // Crear capacidad general - usar el servicio existente
          resultado = await this.logisticaService.crear_capacidades(
            id_poli,
            cod_bodega,
            formValues.cierre_automatico || this.cierre_automatico,
            formValues.porcentaje_cierre,
            formValues.cubicaje,
            formValues.cantidad_ops,
            usuario
          );
          
          if (resultado.success) {
              const mensaje = this.capacidadPorDia ? "Capacidades por día creadas exitosamente" : "Capacidades creadas exitosamente";
          
              // Crear alertas automáticamente usando los IDs insertados
              await this.logisticaService.crearAlertasAutomaticas(resultado.id_reg, usuario)
              this.helpers.notifications.successMessage(mensaje);
              await CrearPoligonoComponent.changeValueDialog(1);
              this.dialogClose();
        } else {
          this.helpers.notifications.errorMessage(resultado.message || 'No se pudieron crear las capacidades.');
        }
      }
       hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else if (this.action == 'new_alert') {

      try {
        
        const USUARIO_CREACION = getCurrentUser().usuario_aplicativo || '';
        const ID_REG_CAPAC = this.data.ID_REG_CAPAC.toString();

        const alertaData = {
          ID_REG_CAPAC,
          PORC_AVANCE: parseFloat(this.form.value.PORC_AVANCE),
          ASUNTO: this.form.value.ASUNTO,
          DESTINATARIOS: this.form.value.DESTINATARIOS,
          USUARIO_CREACION
        };

        const resultado = await this.logisticaService.crearAlerta(
          alertaData
        );
        if (resultado.success) {
          this.helpers.notifications.successMessage("Alerta creada exitosamente");
          await ModalAlertasComponent.changeValueDialog(1);
          this.dialogClose();
          /* this.dialogRef.close({ success: true, refresh: true, tipo:'new'}); */
        } else {
          this.helpers.notifications.errorMessage(resultado.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else if (this.action == 'edit_alert') {
      try {
        const USUARIO_MODIFICACION = getCurrentUser().usuario_aplicativo || '';
        const ID_REG_CAPAC = this.data.ID_REG_CAPAC.toString();
        const ID_ALERT = this.data.ID_ALERT.toString();

        const alertaData = {
          ID_REG_CAPAC,
          ID_ALERT,
          PORC_AVANCE: this.form.value.PORC_AVANCE ? parseFloat(this.form.value.PORC_AVANCE) : null,
          ASUNTO: this.form.value.ASUNTO || null,
          DESTINATARIOS: this.form.value.DESTINATARIOS || null,
          USUARIO_MODIFICACION,
          ESTADO: this.data.ESTADO || null
        };

        const resultado = await this.logisticaService.editarAlerta(alertaData);
        if (resultado.success) {
          this.helpers.notifications.successMessage("Alerta actualizada exitosamente");
          await ModalAlertasComponent.changeValueDialog(1);
          this.dialogClose();
        } else {
          this.helpers.notifications.errorMessage(resultado.message);
        }
        hideSpinner();
      } catch (error) {
        hideSpinner();
        const message = getErrorMessage(error);
        this.helpers.notifications.errorMessage(message);
      }
    }else if (this.action == 'estado_alert') {
      try {
        const ID_ALERT = this.data.ID_ALERT.toString();
        // Invertir el estado actual del polígono
        const ESTADO = this.data.ESTADO === 'A' ? 'I' : 'A'
        const usuario = getCurrentUser().usuario_aplicativo || '';
        const result = await this.logisticaService.cambiarEstadoAlerta(
          ID_ALERT,
          ESTADO,
          usuario
        )
        if (result.success) {
          this.helpers.notifications.successMessage(result.message);
          await ModalAlertasComponent.changeValueDialog(1);
          this.dialogClose();
          /* this.dialogRef.close({ success: true, refresh: true, tipo:'delete', id_poli:id_poli }); */
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    }
  }
  dialogClose() {
    this.dialogRef.close();
  }

  async cargarDepartamentos() {
    try {
      showSpinner();
      const resp = await this.logisticaService.obtener_departamento();
      if (resp && resp.success && Array.isArray(resp.data)) {
        this.departamentosOriginal = resp.data;
        // Inicializar el filtro
        this.filtroDepartamento = '';
      }
    } finally { hideSpinner(); }
  }

  async cargarMunicipios() {
    try {
      showSpinner();
      const resp = await this.logisticaService.obtener_municipio();
      if (resp && resp.success && Array.isArray(resp.data)) {
        this.municipiosOriginal = resp.data;
        // Inicializar el filtro
        this.filtroMunicipio = '';
      }
    } finally { hideSpinner(); }
  }

  async cargarZonas() {
    try {
      showSpinner();
      const resp = await this.logisticaService.obtener_zona();
      if (resp && resp.success && Array.isArray(resp.data)) {
        this.zonasOriginal = resp.data;
        // Inicializar el filtro
        this.filtroZona = '';
      }
    } finally { hideSpinner(); }
  }

  // Función genérica de filtrado
  filtrar(array: any[], value: string, key: string): any[] {
    const filterValue = value.toLowerCase();
    return array.filter(option => option[key].toLowerCase().includes(filterValue));
  }



  toggleDepartamento(dep: any) {
    const i = this.departamentosSeleccionados.findIndex(d => d.CODIGO_DEPARTAMENTO === dep.CODIGO_DEPARTAMENTO);
    if (i >= 0) {
      this.departamentosSeleccionados.splice(i, 1);
    } else {
      this.departamentosSeleccionados.push(dep);
    }
  }
  isDepartamentoSelected(dep: any): boolean {
    return this.departamentosSeleccionados.some(d => d.CODIGO_DEPARTAMENTO === dep.CODIGO_DEPARTAMENTO);
  }

  toggleMunicipio(mun: any) {
    const i = this.municipiosSeleccionados.findIndex(
      m =>
        m.CODIGO_MUNICIPIO === mun.CODIGO_MUNICIPIO &&
        m.CODIGO_DEPARTAMENTO === mun.CODIGO_DEPARTAMENTO
    );
    
    if (i >= 0) {
      this.municipiosSeleccionados.splice(i, 1);
    } else {
      this.municipiosSeleccionados.push(mun);
    }
  }


  isMunicipioSelected(mun: any): boolean {
    return this.municipiosSeleccionados.some(
      m =>
        m.CODIGO_MUNICIPIO === mun.CODIGO_MUNICIPIO &&
        m.CODIGO_DEPARTAMENTO === mun.CODIGO_DEPARTAMENTO
    );
  }

  toggleZona(zona: any) {
    const i = this.zonasSeleccionados.findIndex(
      z => 
        z.CODIGO_ZONA === zona.CODIGO_ZONA && 
        z.CODIGO_MUNICIPIO === zona.CODIGO_MUNICIPIO && 
        z.CODIGO_DEPARTAMENTO === zona.CODIGO_DEPARTAMENTO 
      );
    if (i >= 0) {
      this.zonasSeleccionados.splice(i, 1);
    } else {
      this.zonasSeleccionados.push(zona);
    }
  }
  isZonaSelected(zona: any): boolean {
    return this.zonasSeleccionados.some(
      z => 
        z.CODIGO_ZONA === zona.CODIGO_ZONA &&
        z.CODIGO_MUNICIPIO === zona.CODIGO_MUNICIPIO &&
        z.CODIGO_DEPARTAMENTO === zona.CODIGO_DEPARTAMENTO
    );
  }

  get departamentosFiltrados() {
    return this.departamentosOriginal.filter(d =>
      d.NOMBRE_DEPARTAMENTO.toLowerCase().includes(this.filtroDepartamento.toLowerCase())
    );
  }
  get municipiosFiltrados() {
    return this.municipiosOriginal.filter(m =>
      m.NOMBRE_MUNICIPIO.toLowerCase().includes(this.filtroMunicipio.toLowerCase())
    );
  }
  get zonasFiltrados() {
    return this.zonasOriginal.filter(z =>
      z.NOMBRE_ZONA.toLowerCase().includes(this.filtroZona.toLowerCase())
    );
  }

  // Método para filtrar bodegas
  private _filtrarBodegas(value: string): Item[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.storeBodegas.filter(bodega =>
      bodega.nombre.toLowerCase().includes(filterValue) ||
      bodega.cod.toLowerCase().includes(filterValue)
    );
  }

  toggleCierreAutomatico(event: MatSlideToggleChange): void {
    this.cierre_automatico = event.checked ? 'S' : 'N';

    // Actualizar el valor en el formulario usando patchValue
    this.form.patchValue({
      cierre_automatico: this.cierre_automatico
    });

    if (!event.checked) {
      // Usar patchValue en lugar de asignar directamente a form.value
      this.form.patchValue({
        porcentaje_cierre: ''
      });
    }

    console.log('Cierre automático:', this.cierre_automatico);
  }

  // Método para mostrar el valor seleccionado en el mat-select
  displayBodega(bodega?: Item): string {
    return bodega ? `${bodega.cod} - ${bodega.nombre}` : '';
  }

  // Método para manejar la selección de bodega y actualizar el formulario
  onBodegaSelected(event: any): void {
    const selectedBodega = event.option.value;
    this.cod_bodega = selectedBodega.cod;
    // Actualizar el valor en el formulario
    this.form.patchValue({
      cod_bodega: selectedBodega.cod
    });
    console.log('Bodega seleccionada:', selectedBodega.cod);
  }

  onlyAlphanumeric(event: KeyboardEvent): void {
    const char = String.fromCharCode(event.which);
    if (!/^[a-zA-Z0-9]$/.test(char)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const paste = (event.clipboardData || (window as any).clipboardData).getData('text');
    const cleanText = paste.replace(/[^a-zA-Z0-9]/g, '');
    const control = this.form.get('cod_poligono');
    if (control) {
      control.setValue(cleanText);
    }
  }

  toUpperCase(event: any): void {
    const value = event.target.value.toUpperCase();
    this.form.get('nom_poligono')?.setValue(value);
  }

  toUpperCaseCode(event: any): void {
    const value = event.target.value.toUpperCase();
    this.form.get('cod_poligono')?.setValue(value);
  }

  onlyDecimal(event: KeyboardEvent): void {
    const char = String.fromCharCode(event.which);
    const currentValue = (event.target as HTMLInputElement).value;
    
    // Permitir números, punto decimal y teclas de control
    if (!/^[0-9.]$/.test(char)) {
      event.preventDefault();
      return;
    }
    
    // No permitir más de un punto decimal
    if (char === '.' && currentValue.includes('.')) {
      event.preventDefault();
    }
  }

  onDecimalPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const paste = (event.clipboardData || (window as any).clipboardData).getData('text');
    // Limpiar el texto pegado: solo números y un punto decimal
    const cleanText = paste.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    const control = this.form.get('cubicaje');
    if (control) {
      control.setValue(cleanText);
    }
  }

  onlyInteger(event: KeyboardEvent): void {
    const char = String.fromCharCode(event.which);
    // Solo permitir números
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault();
    }
  }

  onIntegerPaste(event: ClipboardEvent, fieldName: string): void {
    event.preventDefault();
    const paste = (event.clipboardData || (window as any).clipboardData).getData('text');
    // Limpiar el texto pegado: solo números
    const cleanText = paste.replace(/[^0-9]/g, '');
    const control = this.form.get(fieldName);
    if (control) {
      control.setValue(cleanText);
    }
  }

  onCapacidadPorDiaChange(event: any): void {
    this.capacidadPorDia = event.checked;
    if (!this.capacidadPorDia) {
      this.fechasSeleccionadas = [];
    }
  }

  agregarFecha(event: any): void {
    const fecha = event.value;
    if (fecha && !this.fechasSeleccionadas.some(f => f.getTime() === fecha.getTime())) {
      this.fechasSeleccionadas.push(fecha);
      this.calendarioAbierto = true;
      // Reabrir el calendario después de seleccionar una fecha
      setTimeout(() => {
        if (this.datePicker && this.calendarioAbierto) {
          this.datePicker.open();
        }
      }, 50);
    }
  }

  onDatepickerClosed(): void {
    // Solo cerrar si no estamos en modo de selección múltiple
    if (!this.calendarioAbierto) {
      this.calendarioAbierto = false;
    }
  }

  cerrarCalendario(): void {
    this.calendarioAbierto = false;
    if (this.datePicker) {
      this.datePicker.close();
    }
  }

  removerFecha(fecha: Date): void {
    const index = this.fechasSeleccionadas.findIndex(f => f.getTime() === fecha.getTime());
    if (index >= 0) {
      this.fechasSeleccionadas.splice(index, 1);
    }
  }


}

interface Item {
  cod: string;
  nombre: string;
}
